import { styled } from "styled-components";

import { colorCSS } from "../../../styles";
import { redundantCssFromKebab } from "../../../styles/redundant-css";

const width = 24;
const height = 24;
const lineWidth = 3;

export const Icon = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== "isOpen"
})<{ isOpen: boolean }>`
    ${redundantCssFromKebab("background-color", "transparent")}
    ${redundantCssFromKebab("border", "0")}
    ${redundantCssFromKebab("cursor", "pointer")}
    ${redundantCssFromKebab("display", "block")}
    ${redundantCssFromKebab("height", `${height}px`)}
    ${redundantCssFromKebab("margin", "0")}
    ${redundantCssFromKebab("padding", "0")}
    ${redundantCssFromKebab("position", "relative")}
    ${redundantCssFromKebab("width", `${width}px`)}

    span {
        ${redundantCssFromKebab("background-color", `${colorCSS("N800")}`)}
        ${redundantCssFromKebab("border-radius", `${lineWidth}px`)}
        ${redundantCssFromKebab("display", "block")}
        ${redundantCssFromKebab("height", `${lineWidth}px`)}
        ${redundantCssFromKebab("left", "0")}
        ${redundantCssFromKebab("opacity", "1")}
        ${redundantCssFromKebab("position", "absolute")}
        ${redundantCssFromKebab("transform", "rotate(0deg)")}
        ${redundantCssFromKebab("transition", "0.3s ease")}
        ${redundantCssFromKebab("width", `${width}px`)}
    }

    ${({ isOpen }) =>
        isOpen
            ? `
                  span:nth-of-type(1) {
                      left: 0px;
                      top: ${(height - lineWidth) / 2}px;
                      transform: rotate(45deg);
                  }
                  span:nth-of-type(2) {
                      top: ${(height - lineWidth) / 2}px;
                      opacity: 0;
                      width: 0%;
                  }
                  span:nth-of-type(3) {
                      left: 0px;
                      top: ${(height - lineWidth) / 2}px;
                      transform: rotate(-45deg);
                  }
              `
            : `
                  span:nth-of-type(1) {
                      top: ${lineWidth / 2}px;
                      transform-origin: left center;
                  }
                  span:nth-of-type(2) {
                      top: ${(height - lineWidth) / 2}px;
                      transform-origin: left center;
                  }
                  span:nth-of-type(3) {
                      top: ${height - lineWidth * 1.5}px;
                      transform-origin: left center;
                  }
              `}
`;
